export function isTenantId(value?: string): boolean {
  if (!value) {
    return false;
  }
  const num = +value;
  return Number.isInteger(num) && num > 0;
}
